import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--rovo-expansion/rovo-chat-input-full-page';

import { RovoChatInputBanner } from '../../../common/components/rovo-chat-input-banner';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({ productSource, dismiss }: MessageFrontendProps) => {
			const chatSource = 'full-page-chat-input';

			return (
				<RovoChatInputBanner
					onDismiss={dismiss}
					context={{
						productSource,
						chatSource,
					}}
				/>
			);
		},
	},
});
